<div class="signin-error">
  <div class="signin-error__heading">
    {{ messageHeading }}
  </div>
  <div class="signin-error__text">
    {{ message }}
  </div>
</div>